export default __webpack_public_path__ + "static/media/blog-big.06ed5953.png";